import React, { useEffect } from 'react';

import PropTypes, { bool } from 'prop-types';

import Button from '@adsk/alloy-react-button';
import { PlusIcon } from '@adsk/alloy-react-icon';
import { useLocale } from '@adsk/alloy-react-locale';

import { useIsCurrentUserGalleryAccessLimited } from './helpers/hooks';

const PhotoCustomCreateNewButton = ({ onCreateClick, disabled }) => {
  const isCurrentUserGalleryAccessLimited =
    useIsCurrentUserGalleryAccessLimited();

  useEffect(() => {
    // Open upload panel by default
    if (!disabled && isCurrentUserGalleryAccessLimited) onCreateClick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  return (
    <Button
      onClick={onCreateClick}
      variant={Button.VARIANTS.SECONDARY}
      renderIcon={(p) => <PlusIcon {...p} />}
      disabled={disabled}
    >
      {T.translate('UPLOAD_NEW')}
    </Button>
  );
};

PhotoCustomCreateNewButton.propTypes = {
  onCreateClick: PropTypes.func.isRequired,
  disabled: bool,
};

export default PhotoCustomCreateNewButton;
